export default {
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/mixins/filterable.js
// module id = IF+h
// module chunks = 0